import { AutogenLayoutOfficePayrollHistoryReport } from "./autogen/AutogenLayoutOfficePayrollHistoryReport";

export class OfficePayrollHistoryReport extends AutogenLayoutOfficePayrollHistoryReport {
    override onLoad(): void {
        if (this.textboxPayeeType) {
            this.textboxPayeeType.enabled = false;
        }

        // Initialize report with detailed view selected by default
        if (this.switchReportType) {
            this.switchReportType.checked = true; // Detailed report by default (right side)
        }

        this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";

    }

    /** Event handler for include settlement history checkbox changes */
    includeSettlementHistoryChanged() {
        const includeSettlement = this.checkboxIncludeSettlementHistory?.checked;

        if (this.textboxPayeeType) {
            this.textboxPayeeType.enabled = includeSettlement;
        }

        this.excludabletextboxPayee.textbox.clear();
        this.textboxPayeeType.clear();
        if(includeSettlement) {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }

    /** Event handler for report type switch changes */
    reportTypeChanged() {
        const isDetailed = this.switchReportType?.checked;

        // Summary report should uncheck and disable the Include Pay Adjustment History checkbox
        if (this.checkboxIncludePayAdjustmentHistory) {
            if (!isDetailed) {
                // Summary mode - uncheck and disable pay adjustment history
                this.checkboxIncludePayAdjustmentHistory.checked = false;
                this.checkboxIncludePayAdjustmentHistory.enabled = false;
            } else {
                // Detailed mode - enable pay adjustment history
                this.checkboxIncludePayAdjustmentHistory.enabled = true;
            }
        }
    }
}
